module.exports = __webpack_public_path__ + "static/media/dot-menu.0d8a90ea.svg";